import { h } from 'preact';
import StockDetailsPage from '../stock-details-page';
import { Header } from '@cube/blocks';
import style from './style';
import { Text } from 'preact-i18n';

const INTL_NS = 'holdings-panel';

import { HoldingsDataTable, InsiderTransactionsDataTable } from '../stock-data-table/holdings';

export default function HoldingsPanel({ ...props }) {
	return (
		<StockDetailsPage {...props}>
			<Header class={style.dataHeader} title={<Text id={`${INTL_NS}.institutional`} />}>
				<Text id={`currency-indicator`} fields={{ code: 'USD' /* @TODO: I don't think this is correct... not always USD? */ }} />
			</Header>
			<HoldingsDataTable class={style.holdingTable} {...props} />
			<Header class={style.dataHeader} title={<Text id={`${INTL_NS}.insider`} />} />
			<InsiderTransactionsDataTable {...props} />
		</StockDetailsPage>
	);
}
